import React from "react";
import { FormControl, FormGroup, FormLabel } from "react-bootstrap";
import Layout from "components/Layout";
import SubmitButton from "components/SubmitButton";
import { transactionsService } from "services";
import { errorFormating } from "utils/utils";
import { withTranslation } from "react-i18next";

class TransactionsImports extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: false,
			submitted: false,
			errors: {},
			importErrors: [],
			importMessages: [],
			selectedFile: null,
			fileInputKey: 0,
		};
	}

	resetFileInput = () => {
		this.setState((prev) => ({
			selectedFile: null,
			fileInputKey: prev.fileInputKey + 1,
		}));
	};

	handleSwitch = (event) => {
		this.setState({
			[event.target.id]: event.target.checked,
		});
	};

	async handleDownloadTemplate() {
		const response = await transactionsService.downloadImportTemplate();

		const url = window.URL.createObjectURL(response);
		const a = document.createElement("a");
		document.body.appendChild(a);
		a.href = url;
		a.download = "import_template.xlsx";
		a.click();
	}

	handleImport = async (event) => {
		event.preventDefault();
		this.setState({ isLoading: true });

		const { selectedFile } = this.state;

		if (selectedFile) {
			try {
				const formData = new FormData();
				formData.append("filename", selectedFile);
				const response = await transactionsService.prepareImport(formData);

				// Importar aunque haya errores
				this.runImport(response.token);
			} catch (error) {
				console.error("Error during import:", error);
				this.resetFileInput();
				this.setState({
					isLoading: false,
					submitted: true,
					importMessages: [],
					importErrors: [],
					errors: {
						message: this.props.t('transactions.imports.errorOccurred'),
					},
				});
			}
		} else {
			this.setState({
				isLoading: false,
				submitted: true,
				importMessages: [],
				importErrors: [],
				errors: {
					message:
						this.props.t('transactions.imports.noFileSelected'),
				},
			});
		}
	};

	handleResponse = (response) => {
		const importErrors = [];

		// Procesar errores de filas
		if (Array.isArray(response.rows) && response.rows.length > 0) {
			importErrors.push(...response.rows);
		}

		// Procesar errores de cabeceras
		if (response.header && Array.isArray(response.header.errors)) {
			importErrors.push(...response.header.errors);
		}

		this.setState({
			isLoading: false,
			submitted: true,
			errors: response.ok ? {} : { message: "Se ha producido un error" },
			importMessages: [],
			importErrors,
		});
	};

	runImport = async (token) => {
		this.setState({ isLoading: true });

		try {
			const response = await transactionsService.runImport(token);

			if (response.ok) {
				this.setState((prev) => ({
					isLoading: false,
					selectedFile: null,
					fileInputKey: prev.fileInputKey + 1,
					errors: {},
					importErrors: response.has_errors && response.rows.length > 0 ? response.rows : [],
					importMessages: response.rows.length > 0 ? response.rows : [],
				}));
			} else {
				this.setState({
					isLoading: false,
					submitted: true,
					errors: errorFormating(response),
				});
			}
		} catch (error) {
			console.error("Error during import:", error);
			this.resetFileInput();
			this.setState({
				isLoading: false,
				submitted: true,
				importMessages: [],
				importErrors: [],
				errors: {
					message: this.props.t('transactions.imports.errorOccurred'),
				},
			});
		}
	};

	getImportErrors = (rows = [], headerErrors = []) => {
		// Procesar errores de filas
		const rowErrors = rows.map((row, i) => {
			const hasErrors = row.errors && row.errors.length > 0;
			if (!hasErrors) {
				return row.message ? (
					<li key={`row-${i}`}>
						<span className="import-count">{row.message}</span>
					</li>
				) : null;
			}
			return (
				<li key={`row-${i}`}>
					<span className="import-count">{this.props.t('transactions.imports.row', { row: row.row })}</span>
					<ul className="import-details">
						{this.getImportErrorsDetails(row.errors)}
					</ul>
				</li>
			);
		});

		// Procesar errores de cabeceras
		const headerErrorMessages = Array.isArray(headerErrors)
			? headerErrors.map((error, i) => (
				<li key={`header-${i}`}>
					<span className="import-header-error">{error.message}</span>
				</li>
			))
			: [];

		return [...headerErrorMessages, ...rowErrors];
	};

	getImportErrorsDetails = (errors) =>
		(errors || []).map((error, i) => (
			<li key={i}>{error.message}</li>
		));

	getImportMessages = (rows = []) =>
		rows.map((row, i) => {
			const hasErrors = row.errors && row.errors.length > 0;
			if (!hasErrors && row.message) {
				return (
					<li key={i}>
						<span className="import-count">{row.message}</span>
					</li>
				);
			}
			return hasErrors ? null : null;
		});

	handleChange = (event) => {
		this.setState({
			selectedFile: event.target.files[0],
		});
	};

	getContent = () => (
		<form key={this.state.fileInputKey} onSubmit={this.handleImport}>
			<ol className="steps">
				<li className="step-download">
					{this.props.t('transactions.imports.step1Prefix')}{" "}
					<span
						className="link"
						onClick={() => this.handleDownloadTemplate()}
					>
						{this.props.t('transactions.imports.step1Link')}
					</span>{" "}
					{this.props.t('transactions.imports.step1Suffix')}
				</li>
				<li className="step-upload">
					<div className="step-upload-content">
						{this.props.t('transactions.imports.step2')}
						<FormControl
							type="file"
							onChange={this.handleChange}
							className="form-control"
						/>
					</div>
				</li>
			</ol>
			<SubmitButton
				type="submit"
				isLoading={this.state.isLoading}
				text={this.props.t('transactions.imports.submit')}
				loadingText={this.props.t('transactions.imports.submitting')}
			/>
		</form>
	);

	render() {
		const { importErrors, importMessages, errors } = this.state;

		return (
			<Layout className="page-imports">
				<div className="heading">
					<div className="heading-left">
						<h1 className="title">{this.props.t('transactions.imports.title')}</h1>
					</div>
				</div>

				{this.getContent()}

				{errors.message && <p className="error-message">{errors.message}</p>}

				{importErrors.length > 0 && (
					<div className="import-list import-errors">
						<p className="import-list-text">
							{t('transactions.imports.errorsFound')}
						</p>
						<ul className="import-rows">
							{this.getImportErrors(
								importErrors.filter((error) => error.row), // Filtrar errores de filas
								importErrors.filter((error) => !error.row) // Filtrar errores de cabeceras
							)}
						</ul>
					</div>
				)}

				{importMessages.length > 0 && (
					<div className="import-list import-messages">
						<p className="import-list-text">{this.props.t('transactions.imports.importResult')}</p>
						<ul className="import-rows">
							{this.getImportMessages(importMessages)}
						</ul>
					</div>
				)}
			</Layout>
		);
	}
}

export default withTranslation()(TransactionsImports);
